import React, { useEffect, useState } from 'react';
import axiosInstance from '../../API/axiosInstance';
import './blogs.css';
import { toast, ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DynamicBreadcrumbs from '../../components/dynamic_breadcumb/dynamic_breadcrumb';
import { FaFeatherAlt } from 'react-icons/fa';
import DownloadAppUI from '../../ui_components/download_app/download_app';
import SiteFooter from '../../ui_components/site_footer/site_footer';
import { Link } from 'react-router-dom';

// A helper function to format dates
const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
};

export default function Blogs({ homepage }) {
    const [blogs, setBlogs] = useState([]);
    const [token, setToken] = useState(null);
    const [blog, setBlog] = useState({ title: "", content: "" });
    const [selectedFile, setSelectedFile] = useState(null); // PDF/Word
    const [selectedImages, setSelectedImages] = useState([]); // array of images
    const [isPosting, setIsPosting] = useState(false);
    const [currentUser, setCurrentUser] = useState(() => {
        const storedUser = localStorage.getItem("currentUser")
        if (storedUser) {
            return JSON.parse(storedUser)
        }
        else {
            return null
        }
    })

    const handleCreateBlog = async () => {
        if (!blog.title.trim()) {
            notify("error", "Title cannot be empty.");
            return;
        }
        if (!selectedFile) {
            notify("error", "Please upload a content file.");
            return;
        }

        setIsPosting(true);
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("title", blog.title);
            formData.append("authorId", currentUser.id);
            formData.append("authorType", currentUser.role);

            selectedImages.forEach((img) => formData.append("images", img));

            const response = await axiosInstance.post("/blogs/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            notify("success", "Blog created successfully!");
            setBlog({ title: "", content: "" });
            setSelectedFile(null);
            setSelectedImages([]);
            // Close modal
            const modal = document.getElementById("blogModal");
            const bsModal = bootstrap.Modal.getInstance(modal);
            bsModal.hide();

            // Optionally update blog list in UI
            setBlogs((prev) => [response.data, ...prev]);
        } catch (error) {
            console.warn(error);
            notify("error", "Failed to create blog.");
        } finally {
            setIsPosting(false);
        }
    };


    const notify = (status, message) => {
        const options = { position: "top-right", autoClose: 5000, theme: "dark", transition: Bounce };
        if (status === "success") {
            toast.success(message, options);
        } else {
            toast.error(message, options);
        }
    };

    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        const storedUser = localStorage.getItem("currentUser");
        if (storedToken) setToken(storedToken);
        if (storedUser) {
            const user = JSON.parse(storedUser);
            setBlog(prev => ({ ...prev, authorId: user.id, authorType: user.role }));
        }
    }, []);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axiosInstance.get("/blogs");
                if (response.status !== 200) throw new Error("Network response was not ok");
                setBlogs(response.data);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        };
        fetchBlogs();
    }, []);

    const postBlog = async () => {
        if (!blog.title.trim() || !blog.content.trim()) {
            notify("error", "Title and content cannot be empty.");
            return;
        }
        try {
            const response = await axiosInstance.post("/blogs", blog, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 201 || response.status === 200) {
                setBlogs([response.data, ...blogs]); // Add new blog to the top of the list
                setBlog({ ...blog, title: "", content: "" }); // Clear form
                setSelectedFile(null); // Clear selected file
                notify("success", "Blog posted successfully!");
            }
        } catch (error) {
            notify("error", "Blog posting failed.");
            console.error(error);
        }
    };

    // --- NEW FUNCTIONS FOR FILE HANDLING ---

    // Sets the selected file in state
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    // Uploads the file to the backend to extract text
    const handleFileUpload = async () => {
        if (!selectedFile) {
            notify("error", "Please select a file first.");
            return;
        }

        setIsExtracting(true);
        const formData = new FormData();
        // The key 'document' must match the one used in the backend (upload.single('document'))
        formData.append('document', selectedFile);

        try {
            const response = await axiosInstance.post("/blogs/extract-text", formData, {
                headers: {
                    // This header is important for file uploads
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`, // Include auth token if your endpoint is protected
                },
            });

            if (response.status === 200) {
                // Update the blog content with the extracted text
                setBlog({ ...blog, content: response.data.content });
                notify("success", "Content extracted successfully!");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to extract content.";
            notify("error", errorMessage);
            console.error("Error uploading file:", error);
        } finally {
            setIsExtracting(false);
        }
    };


    const renderHomepageView = () => {
        // ... (This function remains unchanged)
        const sliderSettings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 600, settings: { slidesToShow: 1 } }
            ]
        };
        const homepageBlogs = blogs.slice(0, 6);

        return (
            <section className="blog-slider-section">
                <h2 className="section-title m-0 mb-3 text-align-start">Latest Blogs</h2>
                <Slider {...sliderSettings}>
                    {homepageBlogs.map((b) => (
                        <div key={b.id} className="blog-card-wrapper">
                            <div className="blog-slider-card">
                                <img src={`https://picsum.photos/seed/${b.id}/500/300`} alt={b.title} className="blog-card-img" />
                                <div className="blog-card-content">
                                    <span className="blog-card-author">By {b.authorType.toLowerCase()}</span>
                                    <h3 className="blog-card-title">{b.title}</h3>
                                    <Link
                                    className="btn btn-light"
                                    to={`/read-blog/${b.id}`}
                                    state={{ blog: b }}
                                >
                                    Continue Reading →
                                </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </section>
        );
    };

    const renderFullBlogPage = () => (
        <div className="container mt-4">
            <DynamicBreadcrumbs />
            <div className="blog-page-header mb-3">
                <h1 className="blog-page-title m-0">Latest Blogs</h1>
            </div>

            <div className="blog-page-layout">
                <main className="blog-main-content">
                    {blogs.map((b) => (
                        <div key={b.id} className="blog-post-full">
                            {b.imageUrls && b.imageUrls.length > 0 && (
                                <img
                                    src={b.imageUrls[0]}
                                    alt={b.title}
                                    className="blog-post-img"
                                />
                            )}
                            <div className="blog-post-content">
                                <div className="blog-post-meta">
                                    <span className="author">By {b.authorType.toLowerCase()}</span>
                                    <span className="date">{formatDate(b.createdAt)}</span>
                                </div>
                                <h2 className="blog-post-title">{b.title}</h2>
                                <p
                                    className="blog-post-excerpt"
                                    dangerouslySetInnerHTML={{ __html: b.content.substring(0, 200) + "..." }}
                                ></p>

                                <Link
                                    className="read-more-link"
                                    to={`/read-blog/${b.id}`}
                                    state={{ blog: b }}
                                >
                                    Continue Reading →
                                </Link>


                            </div>
                        </div>
                    ))}
                </main>

                <aside className="blog-sidebar">
                    <div className="sidebar-widget">
                        <h4 className="widget-title">Write Your Story</h4>
                        <p>Share your experiences and insights with our community.</p>
                        <button className="btn btn-primary w-100" data-bs-toggle="modal" data-bs-target="#blogModal">
                            <FaFeatherAlt className="me-2" /> Create New Blog
                        </button>
                    </div>
                </aside>
            </div>

            {/* --- UPDATED Blog Creation Modal --- */}
            <div className="modal fade" id="blogModal" tabIndex="-1" aria-labelledby="blogModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="blogModalLabel">Create New Blog</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {/* --- Blog Title --- */}
                            <div className="mb-3">
                                <label htmlFor="blogTitle" className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="blogTitle"
                                    placeholder="Enter blog title"
                                    value={blog.title}
                                    onChange={(e) => setBlog({ ...blog, title: e.target.value })}
                                    required
                                />
                            </div>

                            {/* --- File Upload for Content --- */}
                            <div className="mb-3 p-3 border rounded bg-light">
                                <label htmlFor="fileUpload" className="form-label">
                                    <strong>Upload a Document</strong>
                                </label>
                                <p className="form-text mt-0 mb-2">PDF or Word (.docx) file to populate content automatically.</p>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="fileUpload"
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                    accept=".pdf,.docx"
                                    required
                                />
                            </div>

                            {/* --- Image Upload --- */}
                            <div className="mb-3">
                                <label htmlFor="imageUpload" className="form-label">
                                    Upload Images (Optional)
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="imageUpload"
                                    multiple
                                    onChange={(e) => setSelectedImages(Array.from(e.target.files))}
                                    accept="image/*"
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={handleCreateBlog}>
                                {isPosting ? "Posting..." : "Create Blog"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <section className="my-5">
                {/* Download the app */}
                <div id='download-app-container' className='m-0'>
                    <DownloadAppUI />
                </div>

                {/* Site Footer */}
                <div>
                    <SiteFooter />
                </div>
            </section>
        </div>
    );

    return (
        <>
            <ToastContainer />
            {homepage ? renderHomepageView() : renderFullBlogPage()}
        </>
    );
}